module.exports = __webpack_public_path__ + "static/img/azb0.4ec97ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/azb0.jpg
// module id = fTqk
// module chunks = 1